import axios from "axios";

// Vite automatic VITE_BACKEND_URL ko uthayega, agar nahi mila toh local fallback chalega
const backendBaseUrl = import.meta.env.VITE_BACKEND_URL || "http://localhost:8000";

const apiClient = axios.create({
  baseURL: `${backendBaseUrl}/api`,
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
  },
});

// 🔥 ADVANCED FEATURE: Request Interceptor
// Ye interceptor har API request se pehle automatic check karega ki kya localStorage mein token hai.
// Agar token hoga, toh ye use Authorization Bearer header mein automatic jodh dega.
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default apiClient;